/**
 * Texto em minúsculas sem acentos, para busca em listas.
 */
export function foldAccent(s) {
  return String(s || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase();
}
